<template>
  <div>
    <base-material-card color="secondary" icon="mdi-account" :text="titoloRoutine"
      :title="$t('manage_subscribers')"><v-container>
        <v-row>
          <v-col cols="12">
            <div style="float: left; margin-right: 20px">
              <v-btn v-if="idGara" icon color="green" large @click="goBack()">
                <v-icon>mdi-arrow-left-circle</v-icon>
              </v-btn>
              {{ $t("back") }}

              <v-btn icon color="primary" large style="float: right" @click="loadPartecipanti()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn small class="mx-2" @click="editPartecipante()" color="primary">{{ $t("add_new_subscriber") }}</v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <DataTables :headers="headers" :tableData="tableData" @editPartecipante="editPartecipante"></DataTables>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <base-dialog-form ref="editPartecipanteDialog" :title="method === 'ADD'
      ? this.$t('add_new_subscriber')
      : this.$t('edit_subscriber')
      " height="90vh" :text="method === 'ADD' ? '' : currentPartecipante.ragSoc" color="secondary"
      icon="mdi-format-list-bulleted-type">
      <template v-slot:actions>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" @click="savePartecipante" color="success">{{
            method === "ADD" ? $t("create") : $t("save")
          }}</v-btn>

          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deletePartecipante" color="error">{{ $t("delete")
          }}</v-btn></v-col>
      </template>
      <v-container>
        <v-layout row style="display: none">
          <v-tabs v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
            <v-tab id="tab-title" class="mr-3"> </v-tab>
          </v-tabs>
        </v-layout>
        <v-tabs-items v-model="tabs" class="transparent tabs-container">
          <v-tab-item>
            <v-row>
              <v-col md="6" cols="12">
                <v-row>
                  <v-col md="6" cols="12">
                    <v-select v-model="currentPartecipante.type" :items="typePartecipante" @change="updateAvatar()"
                      :label="$t('type')" item-text="text" item-value="value" color="primary"></v-select>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-switch :true-value="1" :false-value="0" v-model="currentPartecipante.partecipa"
                      :label="$t('enabled_m')"></v-switch>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-text-field v-model="currentPartecipante.ordine" :label="$t('routine')" :rules="required"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col md="4" cols="12">
                    <my-datepicker v-model="currentPartecipante.orario" :label="$t('date_inz')" required="true" /></v-col>
                  <v-col md="4" cols="12">
                    <my-timepicker v-model="currentPartecipante.orario" :use-seconds="true" :label="$t('time_inz')"
                      required="true" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete v-if="currentPartecipante.type === 'user'" v-model="currentPartecipante.masterId"
                      @change="updateAvatar('user')" :items="listUsers" :menu-props="{ maxHeight: '400' }"
                      :label="$t('user')" color="primary" :hint="$t('select_user')" persistent-hint></v-autocomplete>
                    <v-autocomplete v-else-if="currentPartecipante.type === 'asd'" v-model="currentPartecipante.asdCode"
                      :items="listAsd" @change="updateAvatar('asd')" :menu-props="{ maxHeight: '400' }" :label="$t('asd')"
                      color="primary" :hint="$t('select_asd')" persistent-hint></v-autocomplete>
                    <v-text-field v-else v-model="currentPartecipante.ragSoc" :label="$t('ragSoc')" :rules="required"
                      hide-details="auto">
                    </v-text-field></v-col>
                  <v-col cols="12">
                    <v-text-field v-model="currentPartecipante.descr" :label="$t('description')" :rules="required"
                      hide-details="auto">
                    </v-text-field></v-col>
                </v-row>
              </v-col>
              <v-col md="6" cols="12">
                <my-img-uploader ref="imageUploader" v-if="currentPartecipante" v-model="currentPartecipante.imgUrl"
                  :readOnly="method === 'VIEW'" :width="200" :height="200"
                  :placeholder="$t('click_drag_here')"></my-img-uploader>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </base-dialog-form>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import DataTables from "@/components/base/DataTables.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import MyTimepicker from "@/components/base/MyTimepicker.vue";
import MyImageUploader from "@/components/base/MyImageUploader.vue";

export default {
  name: "gest-gara-partecipanti",

  components: {
    DataTables,
    MyDatepicker,
    MyTimepicker,
    "my-img-uploader": MyImageUploader,
  },
  props: {
    idGareDettaglio: null,
  },
  data() {
    return {
      headers: [
        { text: this.$t("status"), value: "status", type: "icons" },
        { text: this.$t("order"), value: "ordine" },
        { text: this.$t("orario"), value: "orario", type: "datetime" },
        { text: this.$t("image"), value: "imgUrl", type: "image" },
        { text: this.$t("ragSoc"), value: "ragSoc" },
        { text: this.$t("description"), value: "descr" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      ifEnte: false,
      tabs: null,
      idGara: null,
      method: null,
      titoloRoutine: null,
      tableData: [],
      listSchede: [],
      listUsers: [],
      typePartecipante: [
        { value: "user", text: this.$t("user") },
        { value: "asd", text: this.$t("asd") },
        { value: "manual", text: this.$t("manual") },
      ],
      currentPartecipante: {},
      initalImage: null,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.push("/portal/eventi/editGaraDettaglio/" + this.idGara);
    },
    updateAvatar(type) {
      if (type && type === "asd")
        this.currentPartecipante.imgUrl =
          "/API/public/ente/getGlobalAvatar/" +
          this.currentPartecipante.asdCode;
      else if (type && type === "user")
        this.currentPartecipante.imgUrl =
          "/API/public/portal/getGlobalAvatar/" +
          this.currentPartecipante.masterId;
      else this.currentPartecipante.imgUrl = "";

      return;
    },
    loadPartecipanti() {
      let _ = this;
      _.isFetching = true;

      let url =
        "/auth/eventi/getGaraDettaglioPartecipanti/" + _.idGareDettaglio;
      // Eventi aperti
      _.chiamataAxios("GET", url).then((response) => {
        _.titoloRoutine = response.data.testata.titolo;
        _.idGara = response.data.testata.idGara;
        _.tableData = response.data.dettaglio.map((item) => {
          item.status = [];
          if (item.partecipa === 1)
            item.status = [
              {
                icon: "mdi-check",
                color: "green",
                text: _.$t("active_m_s"),
              },
            ];
          item.options = [
            {
              icon: "mdi-pencil",
              color: "secondary",
              text: _.$t("edit_subscriber"),
              function: "editPartecipante",
            },
          ];
          return item;
        });
      });
    },
    editPartecipante(item = false) {
      let _ = this;
      if (item) {
        _.method =
          !item || (item.callParms && item.callParms.copy) ? "ADD" : "EDIT";
        _.currentPartecipante = Object.assign({}, item);
      } else {
        _.method = "ADD";
        _.currentPartecipante = {
          type: "manual",
        };
      }
      this.$refs.editPartecipanteDialog.open();
    },
    deletePartecipante() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/eventi/deleteGaraPartecipante/" +
            _.idGareDettaglio +
            "/" +
            _.currentPartecipante.idGarePartecipanti
          ).then((resp) => {
            if (resp.msg.severity === 0) {
              let html = "<strong>" + resp.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadPartecipanti();
              _.$refs.editPartecipanteDialog.close();
            }
          });
        }
      });
    },
    savePartecipante: function () {
      let _ = this;
      _.$refs.imageUploader.updateImage();
      _.chiamataAxios(
        "PUT",
        "/auth/eventi/saveGaraPartecipante/" +
        _.idGareDettaglio +
        "/" +
        (_.method === "EDIT" ? _.currentPartecipante.idGarePartecipanti : ""),
        { body: _.currentPartecipante }
      ).then((resp) => {
        if (resp.msg.severity === 0) {
          let html = "<strong>" + resp.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadPartecipanti();
          _.$refs.editPartecipanteDialog.close();
        }
      });
    },
  },
  computed: {},
  mounted() {
    let _ = this;
    _.ifEnte = window.systemData.ifEnte;
    _.listUsers = [];
    _.chiamataAxios("POST", "/auth/portal/listUsers").then((resp) => {
      _.listUsers = resp.data.map(function (item) {
        return {
          value: item.masterId,
          text:
            item.surname +
            " " +
            item.name +
            "   -   " +
            item.resCity +
            " (" +
            item.eta +
            " anni)",
        };
      });
    });
    _.listAsd = [];
    if (_.ifEnte) {
      _.chiamataAxios("POST", "/auth/ente/listAsd").then((response) => {
        _.listAsd = response.data.map((asd) => {
          return { value: asd.code, text: asd.ragSoc };
        });
      });
    } else {
      _.listAsd.push({
        value: window.systemData.custId,
        text: window.systemData.ASD.ragSoc,
      });
    }

    this.loadPartecipanti();
  },
  watch: {
    idGareDettaglio: function (newVal, oldVal) {
      // watch it
      this.loadPartecipanti();
    },
  },
};
</script>
